import { Loader2, LucideProps } from 'lucide-react'

import { cn } from '@/lib/utils'

export interface LoadingSpinnerProps extends LucideProps {
    className?: string
}

export const LoadingSpinner = ({
    className,
    ...props
}: LoadingSpinnerProps) => {
    return (
        <Loader2 className={cn('animate-spin h-8 w-8', className)} {...props} />
    )
}
